import { Heading } from '@orobix/orobix-fe-components'

import { useStyles } from './PageHeader.styles'

interface PageHeaderProps {
  title: string | React.ReactNode
  right?: React.ReactNode
}

export const PageHeader = ({ title, right }: PageHeaderProps) => {
  const classes = useStyles()

  return (
    <div className={classes.pageHeader} data-testid="pageHeader">
      <div className={classes.title}>
        <Heading noTopMargin noBottomMargin headingLevel="1">
          {title}
        </Heading>
      </div>

      {right && <div>{right}</div>}
    </div>
  )
}
